import type { TModule } from '@modules/core/types';

import { CHARGEBACKS_ROUTES } from './chargebacks';
import { FRAUD_ROUTE_PATHS } from './config';
import { FRAUD_OPERATIONS_ROUTES } from './fraud-operations';
import { LIMIT_OPERATIONS_ROUTES } from './limit-operations';
import { MED_INFRACTIONS_ROUTES } from './med-infractions';
import { USER_FLAGS_ROUTES } from './user-flags';

const fraudModule: TModule = {
  id: 'fraud',
  fallbackRoute: [FRAUD_ROUTE_PATHS.limitOperations],
  permissions: { roles: [] },
  isPublic: false,
  routes: [
    ...LIMIT_OPERATIONS_ROUTES,
    ...CHARGEBACKS_ROUTES,
    ...FRAUD_OPERATIONS_ROUTES,
    ...USER_FLAGS_ROUTES,
    ...MED_INFRACTIONS_ROUTES,
  ],
};

export { FRAUD_ROUTE_PATHS as FraudRoutePaths };

export default fraudModule;
